{
  "tabs": {
    "overview": "Vue d'ensemble",
    "notifications": "Notifications"
  },
  "avatar": {
    "drag_and_drop_statement": "Glissez-déposez votre avatar ici",
    "or_statement": "Ou si vous préférez",
    "cta_label": "Sélectionnez un fichier depuis votre appareil"
  },
  "notifications": {
    "title": "Notifications",
    "label": "Vous pouvez choisir ici quand et comment nous pouvons vous contacter.",
    "cta": {
      "save": "Sauvegarder"
    },
    "ticket_created": {
      "title": "Création",
      "label": "Recevez une notification lorsqu'un ticket est créé"
    },
    "step_change": {
      "title": "Changement d'étape",
      "label": "Recevez une notification lorsqu'un ticket auquel vous êtes rattaché change d'étape"
    },
    "ticket_deleted": {
      "title": "Suppression",
      "label": "Recevez une notification lorsqu'un ticket auquel vous êtes rattaché est supprimé"
    },
    "comment": {
      "title": "Commentaire",
      "label": "Recevez une notification lorsqu'un commentaire est ajouté à un ticket auquel vous êtes rattaché"
    },
    "mention": {
      "title": "Mention",
      "label": "Recevez une notification lorsqu’un utilisateur vous mentionne depuis un commentaire"
    }
  },
  "form": {
    "inputs": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Numéro de téléphone",
      "eps_login": "Login EPS",
      "eps_password": "Mot de passe EPS",
      "idahe_login": "Login IDAHE",
      "idahe_password": "Mot de passe IDAHE"
    }
  },
  "sections": {
    "personal_information": "Informations personnelles",
    "external_accounts": "Comptes IDAHE & EPS"
  },
  "external_accounts": {
    "no_identities": "Aucune entité n'est rattachée à votre compte."
  },
  "update": {
    "response_success": "Profil mis à jour avec succès"
  },
  "ticket_created": {
    "title": "Création",
    "label": "Recevoir une notification lorsqu'un ticket est créé"
  },
  "step_change": {
    "title": "Changement d'étape",
    "label": "Recevoir une notification lorsqu'un ticket auquel vous êtes rattaché change d'étape"
  },
  "ticket_deleted": {
    "title": "Suppression",
    "label": "Recevoir une notification lorsqu'un ticket auquel vous êtes rattaché est supprimé"
  },
  "comment": {
    "title": "Commentaire",
    "label": "Recevoir une notification lorsqu'un commentaire est publié sur un ticket auquel vous êtes rattaché"
  }
}
